import type { WalletAccount } from '../../walletAccount';

type IsHardwareWalletAccountParams = {
  walletAccount: WalletAccount;
};

/**
 * Checks whether a wallet account was connected via a hardware wallet.
 *
 * @param params.walletAccount - The wallet account to check.
 * @returns Whether the wallet account has a hardware wallet vendor set.
 */
export const isHardwareWalletAccount = ({
  walletAccount,
}: IsHardwareWalletAccountParams): boolean =>
  walletAccount.hardwareWalletVendor !== undefined;
